import { useQuery } from '@tanstack/react-query';
import { UsersClient } from '../../services/UsersClient';
import { UserContext } from '../../context/UserProvider';
import { useContext, useState } from 'react';
import { Skeleton } from '../ui/Skeleton';
import { Message } from '../ui/Message';
import { NormChangerDialog } from '../admin/NormChanger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

export const Employee = ({ userId }: { userId: string }) => {
    const user = useContext(UserContext);
    const { data, isPending, isError } = useQuery({
        queryKey: ['employee', userId],
        queryFn: () => UsersClient(user).getUser(userId),
    });
    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => {
        setOpenModal(!openModal);
    };

    if (isError) {
        return (
            <Message type="error">
                Er is iets misgegaan bij het ophalen van de persoonlijke gegevens van de werknemer. Probeer het later nog een keer.
            </Message>
        );
    }

    if (isPending) {
        return (
            <div className="flex flex-col md:flex-row gap-2 w-full">
                {[...Array(5)].map((_, index) => (
                    <Skeleton className="w-full h-[30px] rounded-sm" key={index} />
                ))}
            </div>
        );
    }

    if (!data) return <Message type="info">Geen gebruikersdata gevonden.</Message>;

    return (
        <>
            <ul className="flex flex-wrap md:flex-row gap-3 md:gap-6">
                <li className="flex flex-wrap gap-1 px-6 py-2 rounded bg-secondary">
                    <div className="text-primary">Naam:</div>
                    <div className="text-primary">{data.name}</div>
                </li>
                <li className="flex flex-wrap gap-1 px-6 py-2 rounded bg-secondary">
                    <div className="text-primary">Werkgever:</div>
                    <div className="text-primary">{data.company}</div>
                </li>
                <li className="flex flex-wrap gap-1 px-6 py-2 rounded bg-secondary">
                    <div className="text-primary">Email:</div>
                    <div className="text-primary">{data.email}</div>
                </li>
                <li className="flex flex-wrap gap-1 px-6 py-2 rounded bg-secondary">
                    <div className="text-primary">Afas Id:</div>
                    <div className="text-primary">{data.afasId}</div>
                </li>
                <li className="flex flex-wrap gap-1 px-6 py-2 rounded bg-secondary">
                    <div className="text-primary">Toegestane norm:</div>
                    <div className="text-primary">{data.deviationFromFuelConsumptionPercentage}%</div>
                    <button className="ml-1">
                        <FontAwesomeIcon icon={faPen} className="text-primary" onClick={() => setOpenModal(true)} />
                    </button>
                </li>
            </ul>

            <NormChangerDialog
                open={openModal}
                setOpenModal={toggleModal}
                deviationFromFuelConsumptionPercentage={data.deviationFromFuelConsumptionPercentage}
                userId={userId}
            />
        </>
    );
};
